<template>
  <el-tree
  :data="data"
  :show-checkbox="check"
  node-key="id"
  :default-expanded-keys="expanded"
  :default-checked-keys="checked"
  :props="defaultProps"
  @check-change="checkChange"
  @node-click="nodeClick"
  @check="checkFun"
  :check-on-click-node="onClickNode"
  :highlight-current="true"
  :check-strictly="checkStrictly"
  ref="tree"
  :icon-class="icon">
</el-tree>
</template>

<script>
import {Tree} from '@/plugins/element'
  export default {
    data() {
      return {
        defaultProps: {
          children: 'children',
          label: 'name'
        }
      }
    },
    props:{
      //点击选中
      onClickNode:{
        type:Boolean,
        default:false
      },
      //显示多选框
      check:{
        type:Boolean,
        default:true
      },
      //数据
      data:{
        type:Array
      },
      //打开节点
      expanded:{
        type:Array
      },
      //选中节点
      checked:{
        type:Array
      },
      //是否遵循父子不互相关联
      checkStrictly:{
        type:Boolean,
        default:false
      },
      icon:{
        type:String,
        default:null
      }
    },
    components:{
      Tree
    },
     methods:{
      //选中改变
      checkChange(A,B,C){
        // console.info(A,B,C);
      },
      //点击节点
      nodeClick(A,B,C){
        // console.info(A,B,C);
        // this.$emit('return-',);
      },
      //点击复选框(current:当前选中;all:所有选中)
      checkFun(current,all){
        // console.info(current,all);
        if(this.check){
          this.$emit('return-all',all.checkedKeys);
        }else{
          this.$emit('return-current',current);
        }
        
      },
      //获取选中的id数组
      getCheckedKeys() {
        return this.$refs.tree.getCheckedKeys();
      },
      //设置选中
      setCheckedKeys(array){
        // console.info('setCheckedKeys',array);
        this.$refs.tree.setCheckedKeys(array,false);
      },
      //设置当前
      setCurrentKey(key){
        this.$refs.tree.setCurrentKey(key);
      }
    }
  }
</script>